import { Box, TextField, Tooltip, Typography } from "@mui/material";
import InfoIcon from "../../../../Assets/InfoIcon.png";

/**
 * City add/edit → "Minimum booking hours" (city.minBookingHours).
 * Main hourly services must be booked for at least these hours in this city. 0 = no minimum.
 * Same look as the "Order can after time" / "Buffer time" row.
 */
function MinBookingHoursField({ value, onChange }) {
  return (
    <Box
      width="100%"
      bgcolor="white"
      borderRadius="6px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box width="95%" display="flex" justifyContent="space-between">
        <Box sx={{ width: "49%", marginY: "0.350rem" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
            <Typography fontSize="12px" style={{ userSelect: "none" }}>
              Minimum booking hours
            </Typography>
            <Tooltip title="Main services must be booked for at least these hours in this city. 0 = no minimum.">
              <img src={InfoIcon} height="10px" alt="" />
            </Tooltip>
          </Box>

          <TextField
            placeholder="0 = no minimum"
            type="number"
            size="small"
            inputProps={{ min: 0, max: 24, step: 1 }}
            sx={{
              width: "100%",
              height: "2.3rem",
              backgroundColor: "#F6F6F6",
              borderRadius: "6px",
              "& fieldset": { border: "none" },
              "& .MuiFormLabel-root": { color: "#969696" },
              "& .MuiFormLabel-root.Mui-focused": { color: "primary.main" },
              "& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                fontSize: "0.8rem",
              },
            }}
            InputLabelProps={{ shrink: true }}
            value={value}
            onChange={(e) => {
              const v = e.target.value;
              if (v === "") {
                onChange("");
                return;
              }
              const n = Math.max(0, Math.min(24, parseInt(v, 10) || 0));
              onChange(n);
            }}
            onWheel={(e) => e.target.blur()}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default MinBookingHoursField;
